import { inject, Injectable } from '@angular/core';
import {
  IFormResponse,
  IFormTemplate,
  IFormUpdate,
  PublishFormTemplate,
} from '../interfaces';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FormBuilderService {
  readonly #http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/form-builder`;

  getFormTemplates(): Observable<IFormTemplate[]> {
    return this.#http.get<IFormTemplate[]>(`${this.apiUrl}/get-form-templates`);
  }

  createFormTemplate(template: PublishFormTemplate): Observable<IFormTemplate> {
    return this.#http.post<IFormTemplate>(
      `${this.apiUrl}/create-form-template`,
      template,
    );
  }

  updateFormTemplate(
    template: IFormUpdate,
    templateId: string,
  ): Observable<IFormTemplate> {
    return this.#http.put<IFormTemplate>(
      `${this.apiUrl}/update-form-template/${templateId}`,
      template,
    );
  }

  deleteFormTemplate(templateId: string): Observable<void> {
    return this.#http.delete<void>(
      `${this.apiUrl}/delete-form-template/${templateId}`,
    );
  }

  getFormTemplateById(templateId: string): Observable<IFormTemplate> {
    return this.#http.get<IFormTemplate>(
      `${this.apiUrl}/get-form-template-by-id/${templateId}`,
    );
  }

  getFormResponse(responseId: string): Observable<IFormResponse> {
    return this.#http.get<IFormResponse>(
      this.apiUrl + '/get-form-response/' + responseId,
    );
  }
}
